import React from 'react'
import PropTypes from 'prop-types'

import ContentOverview from 'experienceComponents/ContentOverview'
import {
  HeaderBackground,
  HeaderContent,
  HeaderWrapper,
  StyledHairline,
  StyledTabButton,
  StyledTabSet,
} from './component.styles'
import SiteSelector, {
  SiteSelectorK8WrapperDark,
} from 'components/SiteSelector'

const AdvisoryActivitiesHeader = ({
  activeContentType,
  contentOverview,
  contentTypes,
  entryId,
  handleContentChange,
  locale,
  shouldShowSiteSelector,
}) => {
  const contentOverviewKey = 'content-overview-key'
  const advisoryHairlineKey = 'advisory-hairline-key'
  const shouldRenderTabs = contentTypes?.length > 1

  return (
    <HeaderWrapper>
      <HeaderBackground />
      {shouldShowSiteSelector && (
        <SiteSelectorK8WrapperDark>
          <SiteSelector />
        </SiteSelectorK8WrapperDark>
      )}
      <HeaderContent>
        <ContentOverview
          {...contentOverview}
          entryId={entryId}
          key={contentOverviewKey}
          locale={locale}
        />
        <StyledHairline key={advisoryHairlineKey} />
        {shouldRenderTabs && (
          <StyledTabSet dataTestId="advisory-activity-tabset">
            {contentTypes.map((contentType, index) => (
              <StyledTabButton
                dataTestId={`advisory-activity-tab-${contentType.title.toLowerCase()}`}
                isActive={activeContentType.title === contentType.title}
                key={index}
                label={contentType.title}
                onClick={() => handleContentChange(contentType)}
              />
            ))}
          </StyledTabSet>
        )}
      </HeaderContent>
    </HeaderWrapper>
  )
}

AdvisoryActivitiesHeader.propTypes = {
  activeContentType: PropTypes.object,
  contentOverview: PropTypes.object,
  contentTypes: PropTypes.array,
  entryId: PropTypes.string,
  handleContentChange: PropTypes.func,
  locale: PropTypes.string,
  shouldShowSiteSelector: PropTypes.bool,
}

export default AdvisoryActivitiesHeader
